<template>
    <div>
        <breadcrumbs
            :title="'Skup'"
            :breadcrumbs="breadcrumbs"
        >
        </breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Novi skup</h5><br>
            </div>
            <div class="ibox-content">
                <skup-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                >
                </skup-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import SkupForma from "./SkupForma";
export default {
    name: "KupacCreate",
    components: { SkupForma, Breadcrumbs},
    props: ['user'],
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi',
                    name: 'Skupovi'
                },
                {
                    path: '/skupovi/create',
                    name: 'Novi skup'
                }
            ]
        }
    },
    mounted() {
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
